import {
  MessageClassInfo,
  MessageInstituteInfo,
} from '../../apis/messaging/messaging.interfaces';

export const mockClasses: MessageClassInfo[] = [
  {
    _id: 'class1',
    level_name: 'Grade 11',
    class_code: 'XI-A',
    grade: '11',
    section: 'A',
  },
  {
    _id: 'class2',
    level_name: 'Grade 12',
    class_code: 'XII-B',
    grade: '12',
    section: 'B',
  },
];

export const mockInstitute: MessageInstituteInfo = {
  _id: 'inst1',
  institute_name: 'Springfield Public School',
};
